export default __webpack_public_path__ + "static/media/beep.f1c425a6.mp3";